import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Editor from "../../components/Editor";
import { GATEWAY_URL, ORANGU_URL } from '../../env';
import Request from "../../components/Request";
import Localize from "../../components/Localize/Localize";
import LocalizeKeys from "../../components/Localize/LocalizeKeys";
import TriggerActionService from "../../components/TriggerActionService";
import ActionTriggerConstants from "../../components/ActionTriggerConstants";
import { DataPage, DataPageModal } from "../../components/DataPage";
import CurrencyAmount from "../../components/CurrencyAmount";

class Invoices extends React.Component {

  state = {
    loading: false,
    error: false,
    contents: null,
    isSingleInvoice: false, // /invoice/<transactionCode> shows one invoice with no table
    selectedViewContent: null, // Holds the invoice shown in the detail popup / card
  };

  columns = require('./table.js').columns(this);

  async componentDidMount() {
    // Fire-and-forget async trigger action
    TriggerActionService.sendTriggerAction(ActionTriggerConstants.LANDING_OPEN, "", {
        sourceUrl: "Invoices"
    }).catch((e) => {
        console.warn("[-] TriggerActionService failed", e);
    });

    // Called with params or not?
    const parts = window.location.pathname.split("/").filter(part => part !== "");
    console.log("parts: " + parts);
    if (parts.length >= 2) {
      // Show single invoice
      const location = parts[1];
      console.log(location);
      const response = await Request.POST(ORANGU_URL + "/invoices/get", { "env": "pro", "transaction_code" : location });
      console.log("response: " + JSON.stringify(response));

      const ef = response[0];

      ef.transactionCode = ef.transaction_code;
      ef.total = ef.gross + ef.net;
      ef.concept = Localize.translate("LANDING_CONCEPT_" + ef.concept.toUpperCase());

      //alert(JSON.stringify(response));
      this.setState({
        loading: false,
        selectedViewContent: ef,
        isSingleInvoice: true,
      });

    }
    else {
      // Show invoices by user
      await this.getContents();
    }
  }

  async getContents() {
    try {
      this.setState({
        loading: true,
        error: false,
      });

      const response = await Request.GET(`${GATEWAY_URL}/OrdersService/GetInvoicesByToken`);
      
      const output = response.invoices
          .filter((x) =>
              x.concept === "deposit" &&
              (x.validationStatus === undefined || x.validationStatus === 0)
          )
          .map((x) => ({
            ...x,
            total: x.gross + x.net,
            // `total` stays numeric for the detail text; `amount` is what the table column renders.
            // No sign: an invoice total is not a balance movement.
            amount: <CurrencyAmount amount={x.gross + x.net} currencyType="RealMoney" showSign={false} />,
            concept: Localize.translate("LANDING_CONCEPT_" + x.concept.toUpperCase()),
          }));

      this.setState({
        loading: false,
        contents: output,
      });

    } catch (error) {
      console.error("Error fetching invoices:", error);
      this.setState({
        error: true,
        loading: false,
      });
    }
  }

  handleView = (row) => {
    this.setState({ selectedViewContent: row });
  };

  handleBack = () => {
    this.setState({ selectedViewContent: null });
  };

  renderInvoiceDetails = (content) => {
    return (
        <div style={{ lineHeight: "1.3", fontSize: "1rem" }}>
          <p>
            {Localize.translateAndFormat(LocalizeKeys.INVOICE_TANGELO, 
                {"$date":content.date,
                "$transactionCode":content.transactionCode,
                "$concept":content.concept,
                "$total": `${parseFloat(content.total).toFixed(2).toLocaleString('en-US')}${content.currency_code ? ' ' + content.currency_code : ''}`
            })}
          </p>
          {(content.vat && content.vat > 0) ? 
          <p>{Localize.translateAndFormat(LocalizeKeys.INVOICE_VAT)}</p> : 
          <p>{Localize.translateAndFormat(LocalizeKeys.INVOICE_0_VAT)}</p> }
        </div>
    );
  };
  
  render() {
    const { loading, error, contents, isSingleInvoice, selectedViewContent } = this.state;
    // Only the Dashboard renders a NavBar above this screen; /invoice/* has none.
    const { hasNavBar = false } = this.props;
    const title = `${Localize.translate(LocalizeKeys.INVOICE)} ${selectedViewContent ? selectedViewContent.transactionCode : ""}:`;

    return (
        <React.Fragment>
          <DataPage hasNavBar={hasNavBar}>
            {loading && <CircularProgress style={{ textAlign: "center", marginBottom: "5px" }} />}
            {error && <p>{Localize.translate(LocalizeKeys.INVOICES_ERROR)}</p>}

            {/* Single invoice deep link: no table to overlay, so the detail is shown inline. */}
            {isSingleInvoice && selectedViewContent && (
                <div className="data-page-card">
                  <h2 className="data-page-modal-title">{title}</h2>
                  {this.renderInvoiceDetails(selectedViewContent)}
                </div>
            )}

            {!isSingleInvoice && !loading && !error && contents && (
                <div>
                  <h2 style={{ textAlign: "center", marginBottom: "5px" }}>{Localize.translate(LocalizeKeys.INVOICES_TITLE)}</h2>
                  {contents.length > 0 ? (
                      <Editor
                          data={contents}
                          columns={this.columns}
                          isEditable={false}
                          isDeletable={false}
                          isViewable={true}
                          onView={this.handleView}
                      />
                  ) : (
                      <p style={{ textAlign: "center" }}>{Localize.translate(LocalizeKeys.INVOICES_NOT_FOUND)}</p>
                  )}
                </div>
            )}
          </DataPage>
          {!isSingleInvoice && selectedViewContent && (
              <DataPageModal title={title} onClose={this.handleBack}>
                {this.renderInvoiceDetails(selectedViewContent)}
              </DataPageModal>
          )}
        </React.Fragment>
    );
  }
}

export default Invoices;
